import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface RotatingTaglineProps {
  lang?: 'en' | 'fr' | 'de' | 'it';
  interval?: number;
}

const RotatingTagline: React.FC<RotatingTaglineProps> = ({
  lang = 'en',
  interval = 4000
}) => {
  const taglines = {
    en: [
      'The future of Swiss table tennis',
      'Built by players, for players',
      'Next-gen table tennis statistics',
      'Track your progress, level up your game'
    ],
    fr: [
      'Le futur du tennis de table suisse',
      'Fait par des joueurs, pour des joueurs',
      'Statistiques nouvelle génération',
      'Suis ta progression, améliore ton jeu'
    ],
    de: [
      'Die Zukunft des Schweizer Tischtennis',
      'Von Spielern für Spieler',
      'Next-Gen Tischtennis-Statistiken',
      'Verfolge deinen Fortschritt, verbessere dein Spiel'
    ],
    it: [
      'Il futuro del ping pong svizzero',
      'Fatto da giocatori per giocatori',
      'Statistiche di nuova generazione',
      'Segui i tuoi progressi, migliora il tuo gioco'
    ]
  };

  const currentTaglines = taglines[lang];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % currentTaglines.length);
    }, interval);

    return () => clearInterval(timer);
  }, [currentTaglines.length, interval]);

  const currentText = currentTaglines[currentIndex];
  const staggerDelay = 0.02;

  return (
    <div className="h-8 mb-8 flex items-center justify-center">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          className="text-gray-500 text-lg flex"
        >
          {currentText.split('').map((char, index) => (
            <motion.span
              key={`${currentIndex}-${index}`}
              className="inline-block"
              initial={{
                opacity: 0,
                x: -10
              }}
              animate={{
                opacity: 1,
                x: 0
              }}
              exit={{
                opacity: 0,
                x: 10
              }}
              transition={{
                duration: 0.4,
                delay: index * staggerDelay,
                ease: [0.4, 0, 0.2, 1]
              }}
            >
              {char === ' ' ? '\u00A0' : char}
            </motion.span>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default RotatingTagline;